import React from "react";

export const UiDashboardContent = (props) => {
  return (
    <>
      <div className="df-dashboard-content">{props.children}</div>
    </>
  );
};
